import React from "react";
import NewProjectButton from "./NewProjectButton";

const WelcomeScreen = ({createProject, isCreatingProject}) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div>
                <img src="/TweediaStudioLogo.png" alt="Tweedia Studio Logo" />
            </div>
            <div style={{ 
                width: '400px', 
                height: '200px', 
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center',
            }}>
                <NewProjectButton handleNewProjectClick={createProject} isCreatingProject={isCreatingProject} />
            </div>
        </div>
    )
}

export default WelcomeScreen;